import React, {Component} from 'react';
import {Row, Col, Card, Button} from 'react-materialize';

import problem from '../../images/problem.png';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import {injectIntl, intlShape} from 'react-intl';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
class Five_whys_do extends Component{

    constructor(props){
        super(props);
        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.showDiv= this.showDiv.bind(this);

        this.showDivNo= this.showDivNo.bind(this);
        this.showDivNo2= this.showDivNo2.bind(this);
        this.showDivNo3= this.showDivNo3.bind(this);
        this.showDivNo4= this.showDivNo4.bind(this);
        this.showDivNo5= this.showDivNo5.bind(this);
        this.showDivNo6= this.showDivNo6.bind(this);

        this.showDivYes= this.showDivYes.bind(this);
        this.showDivYes2= this.showDivYes2.bind(this);
        this.showDivYes3= this.showDivYes3.bind(this);
        this.showDivYes4= this.showDivYes4.bind(this);
        this.showDivYes5= this.showDivYes5.bind(this);
        this.showDivYes6= this.showDivYes6.bind(this);


        this.state={
            showComponent: false,

            showComponent1: false, //no components
            showComponent2: false,
            showComponent3: false,
            showComponent4: false,
            showComponent5: false,
            showComponent6: false,

            showComponent7: false, //yes component
            showComponent8: false,
            showComponent9: false,
            showComponent10: false,
            showComponent11: false,
            showComponent12: false,
        }
    }

    handleDownloadPDF= () =>{
        html2canvas(document.getElementById("printDiv")).then( function (canvas){
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            pdf.addImage(imgData, "PNG", 0, 0);
            pdf.save("downloadedPdf.pdf");

        })
    };

    showDiv = (e) => {
        this.setState({
            showComponent: true,
        });
    };

    showDivNo = (e) =>{
        this.setState({
            showComponent1: true,
        });
    };

    showDivNo2 = (e) =>{
        this.setState({
            showComponent2: true,
        });
    };

    showDivNo3 = (e) =>{
        this.setState({
            showComponent3: true,
        });
    };

    showDivNo4 = (e) =>{
        this.setState({
            showComponent4: true,
        });
    };

    showDivNo5 = (e) =>{
        this.setState({
            showComponent5: true,
        });
    };

    showDivNo6 = (e) =>{
        this.setState({
            showComponent6: true,
        });
    };

    showDivYes= (e) =>{
        this.setState({
            showComponent7: true,
        });
    };

    showDivYes2= (e) =>{
        this.setState({
            showComponent8: true,
        });
    };

    showDivYes3= (e) =>{
        this.setState({
            showComponent9: true,
        });
    };

    showDivYes4= (e) =>{
        this.setState({
            showComponent10: true,
        });
    };

    showDivYes5= (e) =>{
        this.setState({
            showComponent11: true,
        });
    };

    showDivYes6= (e) =>{
        this.setState({
            showComponent12: true,
        });
    };

    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'problem.ph', defaultMessage: 'Insira um problema aqui'});
        const placeholder2 = intl.formatMessage({id: 'fw.q1', defaultMessage: 'Por que isso ocorreu?'});
        const placeholder3 = intl.formatMessage({id: 'fw.q3', defaultMessage: 'Se não, por que isso ocorreu?'});
        const placeholder4 = intl.formatMessage({id: 'fw.q5', defaultMessage: 'Quais as possíveis soluções?'});


        return(
            <Card>
                <Row>

                    <div className={"text-center"} align="center">
                        <img src={problem} className={"img"} alt={"Aquasafe logo"} width={"100"} height={"100"}/>
                    </div>

                    <div align={"center"}>

                        <h5><b><FormattedMessage id={"tools.fivewhys.header"} defaultMessage={"Ferramenta 5 Porquês"}/></b></h5>
                    </div>

                    <div id={"printDiv"}>

                        <form action={"#"}>

                            <div id={"printDiv"}>

                            <p><FormattedMessage id={"problem"} defaultMessage={"Problema:"}/></p>
                            <input type={"text"} placeholder={placeholder}/>

                            <input type={"submit"} onClick={this.showDiv} value={"OK"}  style={{backgroundColor: '#1e88e5', color: 'white'}}/>

                            {this.state.showComponent ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder2}/>
                                <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>
                                    <input type={"checkbox"} id={"yes"} onClick={this.showDivYes}/>
                                    <label htmlFor={"yes"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>


                                    <div>

                                        <input type={"checkbox"} id={"no"} onClick={this.showDivNo}/>
                                        <label htmlFor={"no"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>

                                        {this.state.showComponent7 ?
                                            <div className={"hidden-input-yes"}>
                                                <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                <input type={"text"} placeholder={placeholder4} />

                                                <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                            </div> :null }

                                        {this.state.showComponent1 ?
                                            <div className={"hidden-input1"}> <input type={"text"} placeholder={placeholder3}/>

                                                <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>
                                                <input type={"checkbox"} id={"yes2"} onClick={this.showDivYes2}/>
                                                <label htmlFor={"yes2"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>
                                                <div>

                                                    <input type={"checkbox"} id={"no2"} onClick={this.showDivNo2}/>
                                                    <label htmlFor={"no2"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>

                                                    {this.state.showComponent8 ?
                                                        <div className={"hidden-input-yes"}>
                                                            <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                            <input type={"text"} placeholder={placeholder4} />

                                                            <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                                        </div> :null }
                                                    {this.state.showComponent2 ?
                                                        <div className={"hidden-input2"}> <input type={"text"} placeholder={placeholder3}/>
                                                            <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>

                                                            <input type={"checkbox"} id={"yes3"} onClick={this.showDivYes3}/>
                                                            <label htmlFor={"yes3"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>
                                                            <div>

                                                                <input type={"checkbox"} id={"no3"} onClick={this.showDivNo3}/>
                                                                <label htmlFor={"no3"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>

                                                                {this.state.showComponent9 ?
                                                                    <div className={"hidden-input-yes"}>
                                                                        <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                                        <input type={"text"} placeholder={placeholder4} />

                                                                        <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                                                    </div> :null }
                                                                {this.state.showComponent3 ?
                                                                    <div className={"hidden-input3"}> <input type={"text"} placeholder={placeholder3} />
                                                                        <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>

                                                                        <input type={"checkbox"} id={"yes4"} onClick={this.showDivYes4}/>
                                                                        <label htmlFor={"yes4"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>
                                                                        <div>

                                                                            <input type={"checkbox"} id={"no4"} onClick={this.showDivNo4}/>
                                                                            <label htmlFor={"no4"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                                                            {this.state.showComponent10 ?
                                                                                <div className={"hidden-input-yes"}>
                                                                                    <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                                                    <input type={"text"} placeholder={placeholder4} />

                                                                                    <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                                                                </div> :null }
                                                                            {this.state.showComponent4 ?
                                                                                <div className={"hidden-input4"}> <input type={"text"} placeholder={placeholder3} />
                                                                                    <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>

                                                                                    <input type={"checkbox"} id={"yes5"} onClick={this.showDivYes5}/>
                                                                                    <label htmlFor={"yes5"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>
                                                                                    <div>

                                                                                        <input type={"checkbox"} id={"no5"} onClick={this.showDivNo5}/>
                                                                                        <label htmlFor={"no5"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                                                                        {this.state.showComponent11 ?
                                                                                            <div className={"hidden-input-yes"}>
                                                                                                <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                                                                <input type={"text"} placeholder={placeholder4} />

                                                                                                <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                                                                            </div> :null }
                                                                                        {this.state.showComponent5 ?
                                                                                        <div className={"hidden-input5"}> <input type={"text"} placeholder={placeholder3}/>
                                                                                            <p><FormattedMessage id={"fw.q2"} defaultMessage={"Isso é uma causa raiz?"}/></p>

                                                                                            <input type={"checkbox"} id={"yes6"} onClick={this.showDivYes6}/>
                                                                                            <label htmlFor={"yes6"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>
                                                                                            <div>

                                                                                                <input type={"checkbox"} id={"no6"} onClick={this.showDivNo6}/>
                                                                                                <label htmlFor={"no6"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                                                                                                {this.state.showComponent12 ?
                                                                                                    <div className={"hidden-input-yes"}>
                                                                                                        <p><FormattedMessage id={"root"} defaultMessage={"Causa raiz:"}/></p>
                                                                                                        <input type={"text"} placeholder={placeholder4} />

                                                                                                        <Button onClick={this.handleDownloadPDF}>PDF</Button>
                                                                                                    </div> :null }
                                                                                                {this.state.showComponent6 ?
                                                                                                    <div className={"hidden-input6"}>
                                                                                                        <p className={"warning"}><FormattedMessage id={"fw.final"} defaultMessage={"Você chegou em 6 tentativas! Reveja o método."}/></p>
                                                                                                    </div>:null
                                                                                                }

                                                                                            </div>

                                                                                        </div>: null}

                                                                                    </div>
                                                                                </div>:null }

                                                                        </div>

                                                                    </div>:null }

                                                            </div>
                                                        </div>:null }

                                                </div>

                                            </div>: null}

                                    </div>
                                </div>: null}

                            </div>
                        </form>

                    </div>
                </Row>
        </Card>
        )
    }



}

export default injectIntl(Five_whys_do);